module.exports = __webpack_public_path__ + "img/shiftWork.ce1228fc.svg";